import { request } from '../axios/request';

import {
  FETCH_ORDER_DELIVERY_PENDING,
  FETCH_ORDER_DELIVERY_REJECTED,
  FETCH_ORDER_DELIVERY_FULFILLED,
} from '../constants/orderDelivery';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_ORDER_DELIVERY_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_ORDER_DELIVERY_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_ORDER_DELIVERY_REJECTED,
  error: error,
});

export const deliverOrder = (orderPk, data) => (dispatch) => {
  dispatch(pending());

  request({
    method: 'post',
    url: `${$U.ORDER_DELIVER}${orderPk}`,
    data: data,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/orderDelivery.js